import { bonipagService } from 'Core/externals/Bonipag'
import { BraspagScheduleModel } from 'Core/Model/BraspagSchedule'
import { BraspagScheduleParser } from 'Core/Parser/BraspagSchedule'

export const getBraspagSchedule = async (
  params, page
) => {
  const parsedModel = BraspagScheduleModel.getBraspagSchedule(params, page)

  const { response } = await bonipagService
    .get('v1/schedules/braspag', { params: parsedModel })
    .then((res) => ({ response: res || null }))
    .catch((err) => ({ response: err.response || null }))

  if (!response) {
    console.error('Error getBraspagSchedule - No response received')
    return [null, true]
  }

  const { data, status } = response

  if (!String(status).startsWith('2')) {
    console.error('Error getBraspagSchedule - Status:', status, 'Data:', data)
    return [null, true]
  }

  return [BraspagScheduleParser.getBraspagSchedule(data), false]
}
